import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import Modal from "../../../../../components/Common/Modal/Modal";
import {
  getModeratorContributorCommentsActionHandler,
  postContributorModeratorCommentsActionHandler,
} from "../../../../../store/actions/actionHandlers/socialActionHandler";
import classes from "./ViewComments.module.scss";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../../../../components/Common/Input/Input";
import Button from "../../../../../components/Common/Button/Button";
import { FormattedMessage } from "react-intl";

const commentSchema = yup.object().shape({
  comment: yup.string().required("Comment is required"),
});

const ViewComments = ({ viewCommentModal, setViewCommentModal }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [comments, setComments] = useState(null);
  const [commentResponseData, setCommentResponseData] = useState(null);
  const methods = useForm({
    resolver: yupResolver(commentSchema),
  });
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  useEffect(() => {
    dispatch(
      getModeratorContributorCommentsActionHandler(
        params?.shotclassId,
        setComments
      )
    );
  }, [dispatch, params, commentResponseData]);

  const modalCloseClick = useCallback(() => {
    setViewCommentModal(false);
  }, [setViewCommentModal]);

  const onSubmit = (data) => {
    setCommentResponseData(null);
    dispatch(
      postContributorModeratorCommentsActionHandler(
        params?.shotclassId,
        data?.comment,
        true,
        setCommentResponseData
      )
    );
  };

  return (
    <Modal
      isOpen={viewCommentModal}
      heading={<FormattedMessage id="Comments_lbl" />}
      toggle={modalCloseClick}
      width={"52"}
    >
      <div className={classes.viewComments}>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} className={classes.post}>
            <Input
              name="comment"
              placeholder="Please enter comment"
              labelColor="light"
              type="text"
              rows={3}
              error={errors?.comment?.message}
              required
            />
            <div className={classes.postbtn}>
              <Button type="submit" label={<FormattedMessage id="POST_TXT" />} small dark />
            </div>
          </form>
        </FormProvider>
        <div className={classes.comments}>
          {comments?.Content?.map((data) => (
            <div key={data?.CreatedAt} className={classes.contributorComments}>
              <div className={classes.contributorUserName}>
                {data?.ContributorUserName} :
              </div>
              <div>{data?.Comments}</div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ViewComments;
